import React, { useEffect, useState, useRef } from "react"
import {
	Avatar,
	Box,
	Button,
	Divider,
	FormControl,
	FormControlLabel,
	Grid,
	IconButton,
	InputLabel,
	List,
	ListItem,
	ListItemAvatar,
	ListItemSecondaryAction,
	ListItemText,
	MenuItem,
	Radio,
	RadioGroup,
	Select,
	TextField,
	TextareaAutosize,
	Tooltip,
	Typography,
	useTheme,
} from "@material-ui/core"
import { Close as CloseIcon, KeyboardArrowDown, InfoOutlined as InfoIcon } from "@material-ui/icons"
import { useFormik } from "formik"
import * as yup from "yup"
import moment from "moment"
import { useDispatch, useSelector } from "react-redux"
import { Skeleton } from "@material-ui/lab"
import { makeStyles } from "@material-ui/core/styles"
import _ from "lodash"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import EditUserSVG from "../icons/EditUserSVG"
import { QAndASvg, SessionSVG } from "../icons"
import { theme } from "highcharts"
import { useLocation } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import SendIcon from "@material-ui/icons/Send"
import { getChat, getChatSuccess, postChat, updateCurrentSession } from "../../actions/viewerActions"
import TypingEffect from "./TypingEffect"

const MenuProps = {
	PaperProps: {
		style: {
			maxWidth: 216,
			maxHeight: 150,
			textTransform: "capitalize",
		},
	},
	anchorOrigin: {
		vertical: "bottom",
		horizontal: "left",
	},
	variant: "menu",
	getContentAnchorEl: null,
}

const AnzyzAsk = () => {
	const useStyles = makeStyles((theme) => ({
		root: {
			"& .MuiListItem-gutters": {
				padding: "0 10px",
			},
			position: "relative",
			"& .MuiListItemAvatar-root": {
				minWidth: "48px",
			},
		},
		button: {
			position: "fixed",
			bottom: theme.spacing(2),
			right: theme.spacing(2),
			zIndex: 9999,
		},
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			boxShadow: theme.shadows[5],
			padding: theme.spacing(2, 4, 3),
			maxHeight: "80%",
			overflowY: "auto",
		},
		scrollButton: {
			position: "absolute",
			bottom: theme.spacing(2),
			right: theme.spacing(2),
		},
		container: {
			display: "flex",
			flexDirection: "column",
			overflow: "auto",
			height: "442px",
			marginBottom: "50px",
		},
		chatWindow: {
			flexGrow: 1,
			overflowY: "auto",
			padding: theme.spacing(1),
			paddingBottom: 0,
		},
		message: {
			marginBottom: theme.spacing(1),
		},
		inputContainer: {
			display: "flex",
			alignItems: "center",
			position: "absolute",
			bottom: 0,
			width: "100%",
			left: -5,
			"& textarea": {
				resize: "none",
				height: "40px",
				padding: "8px",
			},
		},
		textField: {
			flexGrow: 1,
			margin: "10px",
			marginRight: "7px",
			borderRadius: "5px",
			border: `solid 1px ${theme.palette.grey.D400}`,
			"& .MuiOutlinedInput-input": {
				padding: "10px",
				boxShadow: "none",
				transition: "none",
			},
		},
		lineBreak: {
			borderTop: `solid 2px ${theme.palette.grey.D400}`,
			margin: theme.spacing(2, 0),
		},
	}))
	const dispatch = useDispatch()
	const [t] = useTranslation("global")
	const theme = useTheme()
	const classes = useStyles()
	const { documentDetails } = useSelector((state) => state.documentModal)
	const { askAnzyz, currentSessionId, chatLoading, getChatLoading } = useSelector((state) => state.viewerData)
	const { user } = useSelector((state) => state?.authtentication?.user)
	const location = useLocation()
	const [questionAnswer, setQuestionAnswer] = useState([])
	const [questionInput, setQuestionInput] = useState("")
	const [additionalHeight, setAdditionalHeight] = useState(0)
	const [isFocused, setIsFocused] = useState(false)
	const [isNewSession, setIsNewSession] = useState(true)
	const chatWindowRef = useRef(null)
	const messagesEndRef = useRef(null)
	const scrollRef = useRef(null)

	const scrollToBottom = () => {
		const element = document.getElementById("messagesEndRef")
		setTimeout(() => {
			if (element) element?.scrollIntoView({ behavior: "smooth" })
		}, [1200])
	}
	const handleAskQuestion = () => {
		if (chatLoading) return true
		const askAnzyzCopy = { ...askAnzyz }
		const params = location?.pathname?.split("/")
		const fileId = params[params.length - 1]
		if (questionInput.trim() !== "") {
			let newQuestion = {
				question_id: questionAnswer.length + 1,
				user_name: `${user?.first_name} ${user?.last_name}`,
				question: questionInput.trim(),
				answer: "loading",
				timestamp: new Date(),
			}
			if (currentSessionId) {
				//Here we are finding the current session and updating the chat in form of question
				const session = askAnzyzCopy.sessions.find((session) => session.session_id === currentSessionId)
				session?.chats?.push(newQuestion)
				const index = askAnzyzCopy.sessions.findIndex((session) => session.session_id === currentSessionId)
				askAnzyzCopy.sessions[index - 1] = session
				dispatch(getChatSuccess(askAnzyzCopy))
				dispatch(
					postChat({
						file_ids: [fileId],
						session_id: currentSessionId,
						question: questionInput.trim(),
					})
				)
			} else {
				const newSession = {
					session_id: "",
					file_group_id: "",
					created_by_id: "",
					created_by_name: "",
					chats: [newQuestion],
				}
				askAnzyzCopy?.sessions?.push(newSession)
				dispatch(getChatSuccess(askAnzyzCopy))
				dispatch(
					postChat({
						file_ids: [fileId],
						question: questionInput.trim(),
					})
				)
			}
			setQuestionAnswer([...questionAnswer, newQuestion])
			setQuestionInput("")
			scrollToBottom()
		}
	}

	function stringToColor(string) {
		let hash = 0
		let i
		for (i = 0; i < string.length; i += 1) {
			hash = string.charCodeAt(i) + ((hash << 5) - hash)
		}
		let color = "#"
		for (i = 0; i < 3; i += 1) {
			const value = (hash >> (i * 8)) & 0xff
			color += `00${value.toString(16)}`.slice(-2)
		}
		return color
	}

	var getContrast = function (hexcolor) {
		if (hexcolor.slice(0, 1) === "#") {
			hexcolor = hexcolor.slice(1)
		}
		var r = parseInt(hexcolor.substr(0, 2), 16)
		var g = parseInt(hexcolor.substr(2, 2), 16)
		var b = parseInt(hexcolor.substr(4, 2), 16)
		var yiq = (r * 299 + g * 587 + b * 114) / 1000
		return yiq >= 128 ? theme.palette.text.primary : theme.palette.background.default
	}
	const stringAvatar = (name) => {
		return {
			style: {
				...theme?.typography?.avtarText,
				background: stringToColor(name),
				color: getContrast(stringToColor(name)),
				width: "32px",
				height: "32px",
			},
			children: name?.split(" ")[1] ? `${name?.split(" ")[0][0]}${name?.split(" ")[1][0]}` : name?.split(" ")[0][0],
		}
	}

	const getTime = (item) => {
		return `${moment(moment.utc(item?.timestamp)).local().format("LL")} at ${moment(moment.utc(item?.timestamp))
			.local()
			.format("h:mma")}`
	}

	const handleOnFocus = () => {
		if (questionAnswer?.length >= 0) {
			setIsFocused(true)
		} else {
			setIsFocused(false)
		}
	}

	const handleBlur = () => {
		if (questionAnswer?.length >= 0) {
			setIsFocused(true)
		} else {
			setIsFocused(false)
		}
	}

	const questionAnswerList = (data, sessionIndex, sessionArray, chatIndex, chatArray) => {
		return (
			<>
				<ListItem style={{ background: theme.palette.grey.D1400, padding: "10px", marginBottom: "5px" }} alignItems="flex-start">
					<ListItemAvatar>
						<Avatar alt={"A"} {...stringAvatar(data?.user_name)} />
					</ListItemAvatar>
					<ListItemText
						primary={
							<Box style={{ display: "flex" }}>
								<Typography
									component="span"
									variant="fieldValue"
									className={classes.inline}
									style={{ flex: 1 }}
									color="textPrimary"
								>
									{data?.user_name}
								</Typography>
								<Typography
									component="span"
									style={{ flex: 1, ...theme.typography.caption }}
									className={classes.inline}
									color="textPrimary"
								>
									{getTime(data)}
								</Typography>
							</Box>
						}
						secondary={
							<>
								<Typography
									component="p"
									variant="fieldValue"
									style={{ ...theme.typography.fieldValue, color: theme.palette.text.primary, paddingTop: "10px" }}
								>
									{data?.question}
								</Typography>
							</>
						}
					/>
				</ListItem>
				<ListItem style={{ background: theme.palette.grey.D1700, padding: "10px", marginBottom: "5px" }} alignItems="flex-start">
					<ListItemAvatar>
						<QAndASvg width={36} height={36} />
					</ListItemAvatar>
					<ListItemText
						primary={
							<Box style={{ display: "flex" }}>
								<Typography
									component="span"
									variant="fieldValue"
									className={classes.inline}
									style={{ flex: 1 }}
									color="textPrimary"
								>
									{t("qAndA.anzyzAsk")}
								</Typography>
								<Typography
									component="span"
									style={{ flex: 1, ...theme.typography.caption }}
									className={classes.inline}
									color="textPrimary"
								>
									{getTime(data)}
								</Typography>
							</Box>
						}
						secondary={
							<>
								<Typography
									component="p"
									variant="fieldValue"
									style={{ ...theme.typography.fieldValue, color: theme.palette.text.primary, paddingTop: "10px" }}
								>
									{data?.answer === "loading" ? (
										<Skeleton animation="wave" variant="rectangular" height="20px" />
									) : sessionArray.length - 1 === sessionIndex && chatArray.length - 1 === chatIndex ? (
										// <TypingEffect messagesEndRef={messagesEndRef} text={data?.answer} speed={5} />
										<span>{data?.answer}</span>
									) : (
										<span>{data?.answer}</span>
									)}
								</Typography>
							</>
						}
					/>
				</ListItem>
			</>
		)
	}

	const handleNewSession = () => {
		if (scrollRef) {
			dispatch(updateCurrentSession(0))
			scrollRef.current.style.height = "0px"
			const scrollHeight = scrollRef.current.scrollHeight
			scrollRef.current.style.height = scrollHeight + 444 + "px"
			scrollToBottom()
		}
	}

	useEffect(() => {
		scrollToBottom()
	}, [questionAnswer])

	useEffect(() => {
		const params = location?.pathname?.split("/")
		const fileId = params[params.length - 1]
		const payload = {
			file_ids: [fileId],
		}
		dispatch(getChat(payload))
		scrollToBottom()
	}, [])

	useEffect(() => {
		if (askAnzyz) {
			setQuestionAnswer(askAnzyz?.sessions)
			scrollRef.current.style.height = 442
			scrollToBottom()
		}
	}, [askAnzyz])

	return (
		<div className={classes.root}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Box
						style={{
							display: "flex",
							borderBottom: `solid 1px ${theme.palette.grey.D400}`,
							padding: "10px",
							marginBottom: "5px",
							width: "100%",
						}}
					>
						<Box style={{ flex: 20 }}>
							<Typography variant="subtitle1" component="p" style={{ fontWeight: "500" }}>
								{t("qAndA.anzyzAsk")}
							</Typography>
							<Typography variant="subTitle2" component="p" style={{ height: "50px" }}>
								<span style={{ color: theme.palette.grey.D100 }}>File name: </span>
								{documentDetails?.name}
							</Typography>
						</Box>
						<Box style={{ flex: 1, textAlign: "end", alignContent: "center", cursor: "pointer" }} onClick={handleNewSession}>
							<SessionSVG />
						</Box>
					</Box>
					<Box>
						<div className={classes.container}>
							<Paper className={classes.chatWindow}>
								<Box ref={scrollRef} className="scroll-to-bottom">
									<>
										{!isFocused && questionAnswer?.length <= 0 && (
											<Box
												style={{
													background: theme.palette.grey.D1700,
													textAlign: "center",
													padding: "10px",
													marginBottom: "2px",
												}}
											>
												<Box>
													<QAndASvg width={36} height={36} />
												</Box>
												<Box>
													<Typography style={{ ...theme.typography.h6 }}>{t("qAndA.anzyzAsk")}</Typography>
												</Box>
												<Box>
													<Typography variant="subtitle2">{t("qAndA.chatWithDocument")}</Typography>
												</Box>
											</Box>
										)}
										<List className={classes.root}>
											{!isFocused ||
												(questionAnswer?.length >= 0 && (
													<ListItem
														style={{
															background: theme.palette.grey.D1700,
															padding: "10px",
															marginBottom: "5px",
														}}
														alignItems="flex-start"
													>
														<ListItemAvatar>
															<QAndASvg width={36} height={36} />
														</ListItemAvatar>
														<ListItemText
															primary={
																<Box style={{ display: "flex" }}>
																	<Typography
																		component="span"
																		variant="fieldValue"
																		className={classes.inline}
																		style={{ flex: 1 }}
																		color="textPrimary"
																	>
																		{t("qAndA.anzyzAsk")}
																	</Typography>
																</Box>
															}
															secondary={
																<>
																	<Typography
																		component="p"
																		variant="fieldValue"
																		style={{
																			...theme.typography.fieldValue,
																			color: theme.palette.text.primary,
																		}}
																	>
																		{t("qAndA.chatWithDocument")}
																	</Typography>
																</>
															}
														/>
													</ListItem>
												))}
											{getChatLoading ? (
												<>
													<Skeleton
														animation="wave"
														variant="rectangular"
														height="20px"
														style={{ marginBottom: "10px" }}
													/>
													<Skeleton
														animation="wave"
														variant="rectangular"
														height="20px"
														style={{ marginBottom: "10px" }}
													/>
													<Skeleton
														animation="wave"
														variant="rectangular"
														height="20px"
														style={{ marginBottom: "10px" }}
													/>
													<Skeleton
														animation="wave"
														variant="rectangular"
														height="20px"
														style={{ marginBottom: "10px" }}
													/>
													<Skeleton
														animation="wave"
														variant="rectangular"
														height="20px"
														style={{ marginBottom: "10px" }}
													/>
													<Skeleton
														animation="wave"
														variant="rectangular"
														height="20px"
														style={{ marginBottom: "10px" }}
													/>
													<Skeleton
														animation="wave"
														variant="rectangular"
														height="20px"
														style={{ marginBottom: "10px" }}
													/>
													<Skeleton
														animation="wave"
														variant="rectangular"
														height="20px"
														style={{ marginBottom: "10px" }}
													/>
													<Skeleton
														animation="wave"
														variant="rectangular"
														height="20px"
														style={{ marginBottom: "10px" }}
													/>
													<Skeleton
														animation="wave"
														variant="rectangular"
														height="20px"
														style={{ marginBottom: "10px" }}
													/>
													<Skeleton
														animation="wave"
														variant="rectangular"
														height="20px"
														style={{ marginBottom: "10px" }}
													/>
													<Skeleton
														animation="wave"
														variant="rectangular"
														height="20px"
														style={{ marginBottom: "10px" }}
													/>
													<Skeleton
														animation="wave"
														variant="rectangular"
														height="20px"
														style={{ marginBottom: "10px" }}
													/>
													<Skeleton
														animation="wave"
														variant="rectangular"
														height="20px"
														style={{ marginBottom: "10px" }}
													/>
												</>
											) : (
												questionAnswer?.map((session, sessionIndex, sessionArray) => (
													<div>
														{session?.chats?.map((chat, chatIndex, chatArray) =>
															questionAnswerList(chat, sessionIndex, sessionArray, chatIndex, chatArray)
														)}
														<hr className={classes.lineBreak} />
													</div>
												))
											)}
											<div
												id="messagesEndRef"
												//style={{ border: "solid 1px red", height: "100px", width: "100px" }}
												ref={messagesEndRef}
											/>
										</List>
									</>
								</Box>
							</Paper>
							<div className={classes.inputContainer}>
								<TextareaAutosize
									className={classes.textField}
									disabled={chatLoading}
									variant="outlined"
									size="small"
									maxRows={1}
									minRows={1}
									placeholder={t("qAndA.askAnzyzLabel")}
									value={questionInput}
									onChange={(e) => setQuestionInput(e.target.value)}
									onFocus={handleOnFocus}
									onBlur={handleBlur}
									onKeyDown={(e) => {
										if (e.key === "Enter" && !e.shiftKey) {
											e.preventDefault()
											handleAskQuestion()
											return true
										}
									}}
								/>
								<IconButton
									style={{
										background: theme.palette.primary.dark,
										height: "36px",
										width: "36px",
										borderRadius: "5px",
										opacity: chatLoading ? 0.5 : 1,
									}}
									onClick={handleAskQuestion}
								>
									<SendIcon />
								</IconButton>
							</div>
						</div>
					</Box>
				</Grid>
			</Grid>
		</div>
	)
}

export default AnzyzAsk
